import React, { ReactNode } from 'react';
import { Cell, flexRender } from '@tanstack/react-table';

import Icon, { IconProp } from '~components/icon';

import { TableViewRow } from './types';
import { resolveCellAttribute } from './utils';

interface ComponentProps {
  cell: Cell<any, unknown>;
  isEditing: boolean;
  value: any;
  onChange: (newValue: any) => void;
  row: TableViewRow;
  isValid: boolean;
}

const CellContent: React.FC<ComponentProps> = ({ cell, isEditing, value, onChange, row, isValid }) => {
  const { column } = cell;
  const meta = column.columnDef.meta ?? {};
  const context = cell.getContext();
  const dataCy = resolveCellAttribute(meta.dataCy, value);
  if (isEditing && meta.editComponent) {
    return (
      <div className="cell-content">
        <div className="cell-input-container" data-cy={dataCy}>
          <div className="edit-component-wrapper">{meta.editComponent({ value, onChange, row })}</div>

          {!isValid && <span className="validation-error">*</span>}
        </div>
      </div>
    );
  }
  const rendered = flexRender(column.columnDef.cell, context);

  const getContent = (): ReactNode => {
    if (meta.onClick) {
      return (
        <span onClick={() => meta.onClick?.(row)} className="link" data-cy={dataCy}>
          {rendered}
        </span>
      );
    }

    if (meta.link) {
      const href = typeof meta.link === 'function' ? meta.link(row) : meta.link;
      return (
        <a href={href} className="link" data-cy={dataCy}>
          {rendered}
        </a>
      );
    }

    return rendered;
  };

  return (
    <>
      {getContent()}
      {meta.hoverIcon && <Icon icon={meta.hoverIcon as IconProp} className="hover ms-2" size="1x" />}
    </>
  );
};

export default CellContent;
